import { environment } from 'environments/environment';
export const SGF_API = environment.api;
export const ODIN_API = environment.odin;
export const SGF_TYPE = environment.type;
